import React from "react";

function SoloIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_1171_5989)">
        <path
          fill="#fff"
          d="M9.044 1.897l.063-.062 5.058 5.058-.062.063a3.52 3.52 0 01-2.717 1.03L8.014 4.614c-.031-.968.28-1.968 1.03-2.717zM.207 13.232l7.057-7.994 3.498 3.498-1.749 1.561v5.184c0 .28-.25.5-.53.5h-.969c-.28 0-.5-.22-.53-.5v-3.435l-4.216 3.747a.822.822 0 01-1.125-.031L.238 14.357a.822.822 0 01-.031-1.125zm14.74-12.178a3.562 3.562 0 010 5.059l-.063.062-5.06-5.059.063-.062a3.562 3.562 0 015.06 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1171_5989">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(SoloIcon);
